// removed by extract-text-webpack-plugin
module.exports = {"content":"content__3QjYX","title":"title__1kpjK"};


//////////////////
// WEBPACK FOOTER
// ./routes/shipping/styles/ShippingPage.scss
// module id = k4bZ
// module chunks = 1